import { Box, Button, IconButton, InputAdornment, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useContext } from 'react';
import Header from '../../../../components/Header'
import { UserContext } from '../../../../context/UserContext';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import AlertDialogSlide from '../../../../components/AlertDialogSlide';
import MarketProductDialog from '../../../../components/MarketProductDialog';
import MarketProductBox from '../../../../components/MarketProductBox';

function AppMarket() {
  const { token } = useContext(UserContext);

  const [searchKey, setSearchKey] = useState("");
  const [appMarketProducts, setAppMarketProducts] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [productDialogOpen, setProductDialogOpen] = useState(false);
  const [targetProduct, setTargetProduct] = useState(null);
  const [alertDialogOpen, setAlertDialogOpen] = useState(false);
  const [targetProductToDelete, setTargetProductToDelete] = useState(null);



  const fetchProducts = (startIndex) => {
    axios.get(`${process.env.REACT_APP_API_URL}api/alcago/marketProduct/getMarketProducts?token=${token}&searchKey=${searchKey}&startIndex=${startIndex}&limit=10`)
      .catch((err) => {
        console.log("err: " + err);
        if (err.response.data.status === 404) {
          // setAppMarketProducts([]);
          setHasMore(false);
        }
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 200) {
          setHasMore(response.data.marketProducts && response.data.marketProducts.length === 10);
          if (startIndex === 0) {
            setAppMarketProducts([...response.data.marketProducts]);
          } else {
            setAppMarketProducts((prev) => [...prev, ...response.data.marketProducts]);
          }
        }
      });
  }

  useEffect(() => {
    fetchProducts(0);
  }, []);

  useEffect(() => {
    if (targetProduct) {
      setProductDialogOpen(true);
    }
  }, [targetProduct]);

  useEffect(() => {
    if (targetProductToDelete) {
      setAlertDialogOpen(true);
    } else {
      setAlertDialogOpen(false);
    }
  }, [targetProductToDelete]);

  const handleEditProduct = (product) => {
    setTargetProduct(product);
  };

  const handleDeleteProduct = () => {
    axios.delete(`${process.env.REACT_APP_API_URL}api/alcago/marketProduct/deleteMarketProduct?marketProductId=${targetProductToDelete.id}&token=${token}`)
      .catch((err) => {
        console.log("err: " + err);
      })
      .then((response) => {
        if (response && response.data.success === true && response.data.status === 201) {
          setTargetProductToDelete(null);
          fetchProducts(0);
        }
      });
  };

  const handleMarketProductSave = async (values) => {
    if (values.image) {
      await axios.post(`${process.env.REACT_APP_API_URL}api/alcago/marketProduct/uploadMarketProductImage?token=${token}`, {
        image: values.image
      }, {
        headers: {
          "content-type": "multipart/form-data"
        }
      })
        .catch((err) => {
          console.log("err: " + err);
        })
        .then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {

            delete values.image;
            delete values.image_path;
            values.image_path = response.data.photoPath;

          }
        });
    }

    delete values.image;
    if (targetProduct) {
      //update
      delete values.coupons;
      const productIndex = appMarketProducts.findIndex((mp) => mp.id === targetProduct.id);

      if (productIndex !== -1) {
        const updatedProducts = [...appMarketProducts];
        updatedProducts[productIndex] = { ...updatedProducts[productIndex], ...values };
        setAppMarketProducts(updatedProducts);
      }
      delete values.image_link;
      axios.patch(`${process.env.REACT_APP_API_URL}api/alcago/marketProduct/updateMarketProduct?marketProductId=${targetProduct.id}&token=${token}`, { marketProduct: values })
        .catch((err) => {
          console.log("err: " + err);
        })
        .then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {
            setProductDialogOpen(false);
            setTargetProduct(null);
          }
        });
    } else {
      //create
      const newProduct = {
        ...values
      }
      const coupons = [
        ...(newProduct.coupons.split(",").map(coupon => ({ code: coupon.trim() })) || [])
      ]
      delete newProduct.coupons;
      axios.post(`${process.env.REACT_APP_API_URL}api/alcago/marketProduct/?token=${token}`, { marketProduct: newProduct, coupons })
        .catch((err) => {
          console.log("err: " + err);
        })
        .then((response) => {
          if (response && response.data.success === true && response.data.status === 201) {
            setProductDialogOpen(false);
            fetchProducts(0);
          }
        });
    }
  };

  return (
    <Box m="20px 0 20px 20px">
      <AlertDialogSlide
        open={alertDialogOpen} handleClose={() => setTargetProductToDelete(null)}
        clickPositiveAnswer={handleDeleteProduct} clickNegativeAnswer={() => setTargetProductToDelete(null)}
        positiveAnswer={"Sil"} negativeAnswer={"İptal"}
        title={"Bu ürünü silmek istediğinize emin misiniz?"}
        description={"Bu ürün ile ilişkili tüm veriler silinecektir."}
      />
      <MarketProductDialog
        open={productDialogOpen}
        handleClose={() => {
          setProductDialogOpen(false);
          setTargetProduct(null);
        }}
        handleSubmit={handleMarketProductSave}
        marketProduct={targetProduct}
      />
      <Box ml="20px" display="flex" gap="20px">
        <Box width="30%">
          <Header title="Alcago Para Puan Marketi" subtitle="Yeni ürün ekleyebilir, mevcut ürünleri silebilir veya düzenleyebilirsiniz." />
        </Box>
        <TextField
          id="outlined-basic"
          label="Ürün Adı / Açıklaması"
          variant="outlined"
          onChange={(event) => {
            setSearchKey(event.target.value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => fetchProducts(0)}>
                  <SearchOutlinedIcon />
                </IconButton>
              </InputAdornment>
            ),
          }} />
        <Button variant='contained' color='success' sx={{ margin: "10px 0 auto 0" }} onClick={() => {
          setProductDialogOpen(true);
        }}>
          Yeni Ürün Ekle
        </Button>
      </Box>
      <Box>
        <Box mt="10px">
          <InfiniteScroll
            dataLength={appMarketProducts.length}
            next={() => fetchProducts(appMarketProducts.length)}
            hasMore={hasMore}
            loader={<h4>Yükleniyor...</h4>}
            endMessage={
              <p style={{ textAlign: 'center' }}>
                <b>Tüm ürünleri görüntülüyorsunuz.</b>
              </p>
            }
          >
            {appMarketProducts.map((product) => (
              <MarketProductBox
                key={product.id}
                marketProduct={product}
                onEditClick={handleEditProduct}
                onDeleteClick={() => setTargetProductToDelete(product)}
              />
            ))}
          </InfiniteScroll>
        </Box>
      </Box>
    </Box>

  )
}

export default AppMarket